"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaEmpresa = exports.yupEmpresa = void 0;
const yup = __importStar(require("yup"));
const estado_1 = require("./estado");
exports.yupEmpresa = yup.object({
    nome: yup.string().default('').required().label('Nome').max(81, 'Máximo de 81 caracteres.'),
    titulo: yup.string().default('').label('Título').max(80, 'Máximo de 80 caracteres.'),
    mantenedo: yup.string().default('').required().label('Razão Social').max(100, 'Máximo de 100 caracteres.'),
    cnpj: yup.string().default('').required().label('CNPJ').max(18, 'Máximo de 18 caracteres.'),
    cmc: yup.string().default('').label('C.M.C.').max(15, 'Máximo de 15 caracteres.'),
    nomeReduz: yup.string().default('').label('Nome Abreviado').max(30, 'Máximo de 30 caracteres.'),
    nomeTela: yup.string().default('').label('Nome para tela').max(80, 'Máximo de 80 caracteres.'),
    inativa: yup.boolean().required().default(true).label('Empresa inativa'),
    endereco: yup.string().default('').required().label('Endereço').max(40, 'Máximo de 40 caracteres.'),
    bairro: yup.string().default('').required().label('Bairro').max(15, 'Máximo de 15 caracteres.'),
    cidade: yup.string().default('').required().label('Cidade').max(40, 'Máximo de 40 caracteres.'),
    estado: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla))
        .required()
        .default('')
        .label('Estado'),
    cep: yup.string().default('').required().label('CEP').max(10, 'Máximo de 10 caracteres.'),
    // caixa: yup.string().default('').label('Caixa postal'),
    // prefixo: yup.string().default('').label('Prefixo'),
    fone: yup.string().default('').required().label('Telefone').max(15, 'Máximo de 15 caracteres.'),
    // fax: yup.string().default('').label('Fax'),
    secNome: yup.string().default('').label('Nome do secretario(a)').max(40, 'Máximo de 40 caracteres.'),
    secRg: yup.string().default('').label('R.G. do secretário(a)').max(26, 'Máximo de 26 caracteres.'),
    secAto: yup.string().default('').label('Ato do secretário(a)').max(30, 'Máximo de 30 caracteres.'),
    secTitulo: yup.string().default('').label('Título do secretário(a)').max(50, 'Máximo de 50 caracteres.'),
    secDoe: yup.string().default('').label('Doa data do Secretário(a)').max(10, 'Máximo de 10 caracteres.'),
    dirNome: yup.string().default('').label('Nome do diretor(a)').max(40, 'Máximo de 40 caracteres.'),
    dirRg: yup.string().default('').label('R.G. do diretor(a)').max(26, 'Máximo de 26 caracteres.'),
    dirAto: yup.string().default('').label('Ato do diretor(a)').max(30, 'Máximo de 30 caracteres.'),
    dirTitulo: yup.string().default('').label('Título do diretor(a)').max(50, 'Máximo de 50 caracteres.'),
    dirDoe: yup.string().default('').label('Doa data do diretor(a)').max(10, 'Máximo de 10 caracteres.'),
    iee: yup.string().default('').label('I.E.E').max(25, 'Máximo de 25 caracteres.'),
    nre: yup.string().default('').label('N.R.E').max(25, 'Máximo de 25 caracteres.'),
    recEstab: yup.string().default('').label('Rec. Estab.').max(100, 'Máximo de 100 caracteres.'),
    recDoe: yup.string().default('').label('Doe data').max(100, 'Máximo de 100 caracteres.'),
    emailSec: yup.string().default('').email().label('Email secretaria').max(60, 'Máximo de 60 caracteres.'),
    emailTes: yup.string().default('').email().label('Email tesouraria').max(60, 'Máximo de 60 caracteres.'),
    emailAdm: yup.string().default('').email().label('Email administração').max(60, 'Máximo de 60 caracteres.'),
    site: yup.string().default('').label('Endereço do site').max(60, 'Máximo de 60 caracteres.'),
    codInep: yup.string().default('').label('Código INEP').max(10, 'Máximo de 10 caracteres.'),
    // caminhoLogoEscola: yup.string().default('').label('Caminho do Logo da Escola'),
    // hashLogoEscola: yup.string().notRequired().nullable().default(null).label('Hash do arquivo Logo Escola AWS'),
    // caminhoLogoEstado: yup.string().default('').label('Caminho do Logo do Estado'),
    // hashLogoEstado: yup.string().notRequired().nullable().default(null).label('Hash do arquivo Logo Estado AWS'),
    idLogoEmpresa: yup.string().default(null).nullable().label('Logo da Empresa'),
    idLogoEstado: yup.string().default(null).nullable().label('Logo do Estado'),
    autentiqueEmail: yup
        .string()
        .default('')
        .email()
        .label('Email conta autentique')
        .max(521, 'Máximo de 512 caracteres.'),
    autentiqueApikey: yup.string().default('').label('Chave acesso autentique').max(512, 'Máximo de 512 caracteres.'),
    autentiqueEmailTestemunha1: yup
        .string()
        .default('')
        .email()
        .label('Email da testemunha 1 no autentique')
        .max(521, 'Máximo de 512 caracteres.'),
    autentiqueEmailTestemunha2: yup
        .string()
        .default('')
        .email()
        .label('Email da testemunha 2 no autentique')
        .max(521, 'Máximo de 512 caracteres.'),
    autentiqueEmailTestemunha3: yup
        .string()
        .default('')
        .email()
        .label('Email da testemunha 3 no autentique')
        .max(521, 'Máximo de 512 caracteres.'),
});
exports.schemaEmpresa = exports.yupEmpresa.shape({});
